import React, { createContext, useCallback, useEffect, useState } from "react";

export const AuthContext = createContext<{
  isAuthenticated: boolean | undefined
}>({
  isAuthenticated: undefined
})

export const UpdateAuthContext = createContext<{
  login: (value: { email: string, password: string }) => Promise<boolean>
}>({
  login: async (value: { email: string, password: string }) => false
})

export function useAuthContext() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | undefined>(undefined)

  useEffect(() => {
    const token = sessionStorage.getItem('token')
    setIsAuthenticated(!!token)
  }, [])

  const login = useCallback(async (value: { email: string, password: string }) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/apis/client/login`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(value)
      })

      if (!res.ok) throw new Error('ログイン失敗')

      const data = await res.json()
      const { token } = data

      if (token) {
        sessionStorage.setItem('token', token)
        setIsAuthenticated(true)
        return true
      } else {
        setIsAuthenticated(false)
        return false
      }
    } catch {
      console.error('ログイン失敗')
      setIsAuthenticated(false)
      return false
    }
  }, [])

  return {
    isAuthenticated,
    login
  }
}

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, login } = useAuthContext()

  return (
    <UpdateAuthContext.Provider value={{ login }}>
      <AuthContext.Provider value={{ isAuthenticated }}>
        {children}
      </AuthContext.Provider>
    </UpdateAuthContext.Provider>
  )
}